import axios from 'axios'

export default{
    DraftOffer:{
        async Table(data){
            const response = await axios.post(`/api/draftofferoperations/table/customerdraftoffers`,data)
            return response
        },
        async Detail(data){
            const response = await axios.get(`/api/draftofferoperations/get/customerdraftofferdetail/${data}`)
            return response
        },
        async DetailWithChangeRequest(data){
            const response = await axios.get(`/api/draftofferoperations/getdraftpricedetailwithchangerequests/${data}`)
            return response
        },
        async ChangeRequest(data){
            const response = await axios.post(`/api/draftofferoperations/customerchangerequest`,data)
            return response
        },
        async AcceptDraftPrice(data,code){
            const response = await axios.post(`/api/draftofferoperations/acceptallpricesofdraftofferroutes/${data}/${code}`)
            return response
        },
        async AgreementCode(data){
            const response = await axios.post(`/api/draftofferoperations/createagreementcode/${data}`)
            return response
        },
        async AfterSend(data){
            const response = await axios.get(`/api/agreement/get/aftersent/${data}`)
            return response
        },
        async AcceptAgreement(data){
            const response = await axios.post(`/api/agreement/customer/accept/${data}`)
            return response
        },
        async RejectAgreement(data){
            const response = await axios.post(`/api/agreement/customer/reject/${data}`)
            return response
        }
    }
}